import {observer} from 'mobx-react';
import React from 'react';
import {X1LanguageStore} from '../X1LanguageStore';

@observer
export class AddAgeCategoryForm extends React.Component<{ store: X1LanguageStore }> {
  render() {
    const {store} = this.props;

    if (store.addAgeCategory === null)
      return null;

    const name = store.addAgeCategory.name;

    return (
      <div className="row" key="add-form">
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
